(ns ui.view.counterparty-diligence.send-to-responders-modal.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.counterparty-diligence.send-to-responders-modal.model :as model]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::modal-open?
 :<- [::state]
 (fn [state]
   (get-in state model/modal-open-path)))

(rf/reg-sub
 ::submitting?
 :<- [::state]
 (fn [state]
   (get-in state model/submitting-path)))

(rf/reg-sub
 ::new-responders
 :<- [::state]
 (fn [state]
   (get-in state model/new-responders-path)))

(rf/reg-sub
 ::email-subject
 :<- [::state]
 (fn [state]
   (get-in state model/email-subject-path)))

(rf/reg-sub
 ::email-body
 :<- [::state]
 (fn [state]
   (get-in state model/email-body-path)))

(rf/reg-sub
 ::removing-responders
 :<- [::state]
 (fn [state]
   (get-in state model/removing-responders-path)))
